import { z } from "zod";

export const billingSourceSchema = z.enum(["LOCATION", "ORGANIZATION"]);
export type BillingSource = z.infer<typeof billingSourceSchema>;

export const employmentTypeSchema = z.enum(["W2", "F1099"]);
export type EmploymentType = z.infer<typeof employmentTypeSchema>;

export const gigAttachmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  provider: z.string(),
  provider_identifier: z.string(),
  created_ts: z.coerce.date(),
  status: z.enum(["available", "deleted", "pending", "rejected"]),
  resource_url: z.string().url(),
});
export type GigAttachment = z.infer<typeof gigAttachmentSchema>;

export const gigStatusSchema = z.enum([
  "UNAPPROVED",
  "CANCELLED",
  "POSTED",
  "CONFIRMED",
  "UNFILLED",
  "INCOMPLETE",
  "FAILED_PAYMENT",
  "COMPLETED",
]);
export const gigStatuses = gigStatusSchema.options;
/**
 * Schema for gig statuses.
 * UNAPPROVED: Posted from an unapproved location.
 * CANCELLED: Cancelled (whether finished or not).
 * POSTED: Hasn't finished, nobody confirmed.
 * CONFIRMED: Hasn't finished, all pros confirmed.
 * UNFILLED: Finished, nobody confirmed.
 * INCOMPLETE: Finished, confirmed, not completed.
 * FAILED_PAYMENT: Finished, confirmed, failed payment.
 * COMPLETED: Finished, confirmed, completed.
 */
export type GigStatus = z.infer<typeof gigStatusSchema>;

export const gigTypeSchema = z.enum(["MARKETPLACE", "PRIVATE_DIRECT_OFFER", "INTERVIEW", "NETWORK"]);
export const gigTypes = gigTypeSchema.options;
/**
 * Schema for gig types.
 * MARKETPLACE: A classic gig open to the gigpro Marketplace.
 * PRIVATE_DIRECT_OFFER: A private gig offered to a specific pro in the Marketplace.
 * INTERVIEW: A hire interview.
 * NETWORK: A gig posted to network Pros, not available in the Marketplace.
 */
export type GigType = z.infer<typeof gigTypeSchema>;
